<template>
  <base-modal-bottom
    class="c-base-transaction-details"
    ref="transactionDetailsModal"
    title="Informações da Transação"
  >
    <template #btn-close-icon>
      <base-icon
        style="margin: 0 auto"
        width="16"
        height="16"
        name="painel/close-icon"
      />
    </template>

    <BaseTransactionDetailsChargeback
      v-if="category === 'CHARGEBACK'"
      :transaction="transaction"
      :icon="icon"
      v-on:open-reference="emitReferenceTransaction"
    />

    <BaseTransactionDetailsWithdraw
      v-else-if="category === 'WITHDRAW'"
      :transaction="transaction"
      :icon="icon"
    />

    <BaseTransactionDetailsRefund
      v-else-if="category === 'REFUND'"
      v-on:open-reference="emitReferenceTransaction"
      :transaction="transaction"
      :icon="icon"
    />

    <BaseTransactionDetailsGift
      v-else-if="category === 'GIFT'"
      :transaction="transaction"
      :icon="icon"
    />

    <BaseTransactionDetailsShopping
      v-else-if="category === 'SHOPPING'"
      :transaction="transaction"
      :icon="icon"
      :discount="discount"
      :amountTotal="amountTotal"
    />

    <BaseTransactionDetailsShoppingRefund
      v-else-if="category === 'REFUND_ORDER_ITEM'"
      v-on:open-reference="emitReferenceTransaction"
      :transaction="transaction"
      :icon="icon"
    />

    <BaseTransactionDetailsCashback
      v-else-if="category === 'CASHBACK'"
      v-on:open-reference="emitReferenceTransaction"
      :transaction="transaction"
      :icon="icon"
    />

    <BaseTransactionDetailsFutureCashback
      v-else-if="category === 'FUTURE_CASHBACK'"
      v-on:open-reference="emitReferenceTransaction"
      :transaction="transaction"
      :icon="icon"
    />

    <BaseTransactionDetailsPix
      v-else-if="category === 'PIX'"
      :transaction="transaction"
      :icon="icon"
    />
  </base-modal-bottom>
</template>

<script>
import BaseTransactionDetailsShoppingRefund from '@/components/Wallet/BaseTransactionDetailsShoppingRefund.vue'
import BaseTransactionDetailsChargeback from '@/components/Wallet/BaseTransactionDetailsChargeback.vue'
import BaseTransactionDetailsShopping from '@/components/Wallet/BaseTransactionDetailsShopping.vue'
import BaseTransactionDetailsWithdraw from '@/components/Wallet/BaseTransactionDetailsWithdraw.vue'
import BaseTransactionDetailsCashback from '@/components/Wallet/BaseTransactionDetailsCashback.vue'
import BaseTransactionDetailsFutureCashback from '@/components/Wallet/BaseTransactionDetailsFutureCashback.vue'
import BaseTransactionDetailsPix from '@/components/Wallet/BaseTransactionDetailsPix.vue'
import BaseTransactionDetailsRefund from '@/components/Wallet/BaseTransactionDetailsRefund.vue'
import BaseTransactionDetailsGift from '@/components/Wallet/BaseTransactionDetailsGift.vue'
import BaseModalBottom from '@/components/BaseModalBottom.vue'

export default {
  props: {
    transaction: Object,
    icon: String,
    discount: Number,
    amountTotal: Number,
  },

  components: {
    BaseTransactionDetailsShoppingRefund,
    BaseTransactionDetailsFutureCashback,
    BaseTransactionDetailsPix,
    BaseTransactionDetailsChargeback,
    BaseTransactionDetailsShopping,
    BaseTransactionDetailsWithdraw,
    BaseTransactionDetailsCashback,
    BaseTransactionDetailsRefund,
    BaseTransactionDetailsGift,
    BaseModalBottom,
  },

  computed: {
    category() {
      return this.transaction.category.toUpperCase()
    },

    reference() {
      return this.transaction.reference.toUpperCase()
    },

    amount() {
      const category = this.transaction.category.toUpperCase()
      let amount = this.transaction.amount
      if (category === 'WITHDRAW' || category === 'CHARGEBACK') return -amount
      return amount
    },

    transactions() {
      return this.$store.state.wallet.transactions
    },
  },

  methods: {
    open() {
      this.$refs.transactionDetailsModal.open()
    },
    emitReferenceTransaction() {
      this.$refs.transactionDetailsModal.close()
      this.$emit('open-reference', this.transaction.reference_id)
    },
  },
}
</script>

<style lang="scss">
.has-text-underline {
  text-decoration: underline;
}
.c-base-transaction-details {
  &__price {
    margin-bottom: 20px;
    text-align: center;
  }
  &__icon {
    margin-bottom: 5px;
    display: flex;
    justify-content: center;
    color: $support;
  }

  &__discount {
    font-size: 0.8em;
    text-decoration: line-through;
  }

  &__amount {
    font-size: 16px;
    font-weight: bold;
    color: $support;
  }

  &__body {
    max-width: 360px;
    margin: 0 auto;
    .columns:first-child,
    .columns.border-bottom {
      padding-bottom: em(16);
      border-bottom: 1px solid $gray-3;
    }
  }

  &--body-orders {
    .columns {
      padding-bottom: 0 !important;
      margin-bottom: em(7) !important;
      border-bottom: 0 !important;
    }
  }

  &__footer {
    padding-top: em(16);
    border-top: 1px solid $gray-3;
  }

  &--button-bottom {
    padding-top: 32px;
    border-top: 0;
    text-align: center;
  }

  &--pending {
    color: $gray-5;
  }
}
</style>
